import Toaster from "components/common/Toaster";
import React, { useEffect, useRef, useState } from "react";
import Wrapper from "./Wrapper";
import ReactTable from "react-table";
import Button from "components/button/Button";
import Loader from "components/common/Loader";
import EncryptDecrypt from "api/EncryptDecrypt";
import { TABLE } from "helper/constant";
import enhancer from "./add-external-provider-validator";
import { compose } from "redux";
import {
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle
} from "reactstrap";
import RdServices from "api/RdServices";
import CareTeamServices from "api/CareTeamServices";
import CategoryServices from "api/CategoryServices";

const AddExternalProviderModal = props => {
  const toaster = useRef(null);
  const [loader, setLoader] = useState(false);
  const [pageNo, setPageNo] = useState(1);
  const [tblData, setTblData] = useState([]);
  const [stateList, setStateList] = useState([]);
  const [stateName, setStateName] = useState(null);
  const [stateDropdownOpen, setStateDropdownOpen] = useState(false);
  const [stateCode, setStateCode] = useState(null);
  const [searchText, setSearchText] = useState("");
  const [serviceId, setServiceId] = useState(null);
  const [serviceName, setServiceName] = useState(null);
  const [serviceList, setServiceList] = useState([]);
  const [serviceDropdownOpen, setServiceDropdownOpen] = useState(false);

  const hasParam = props.match.params.id;

  const toggleState = () => setStateDropdownOpen(prevState => !prevState);

  const {
    handleChange,
    handleBlur,
    submitCount,
    errors,
    values,
    touched,
    setFieldValue,
    loading,
    editedData,
    action,
    onSubmit,
    resetForm
  } = props;

  useEffect(() => {
    CategoryServices.serviceDropdown()
      .then(res => {
        let data = EncryptDecrypt.decrypt(res.data);
        if (data.status) {
          setServiceList([...data.data]);
        } else {
          if (toaster.current)
            toaster.current.error("Could not fetch services!");
        }
      })
      .catch(err => {
        if (err?.response?.status === 403) {
          if (toaster.current) {
            toaster.current.error("You cannot access this user info!");
            setTimeout(() => {
              props.history.push("/client");
            }, 3000);
          }
        } else {
          if (toaster.current)
            toaster.current.error("Could not fetch services!");
        }
      });
  }, []);

  useEffect(() => {
    RdServices.stateList().then(res => {
      let data = EncryptDecrypt.decrypt(res.data);
      setStateList(data.data);
    });
  }, []);

  useEffect(() => {
    handleSearch(pageNo);
  }, [pageNo]);

  useEffect(() => {
    if (props?.editedData?.services?.id) {
      setServiceId(props?.editedData?.services?.id);
      setServiceName(props?.editedData?.services?.name);
    }
  }, [props?.editedData]);

  const toggleService = () => setServiceDropdownOpen(prevState => !prevState);

  const handleResetForm = () => {
    resetForm();
    setStateCode("");
    setStateName("Select state");
  };

  const formAction = id => {
    let { values, isValid, handleSubmit } = props;
    if (isValid) {
      if (action == "add") {
        const params = {
          user_id: hasParam,
          external_rd_id: id,
          service_id: serviceId
        };

        CareTeamServices.addExternalCareTeam(params)
          .then(res => {
            let data = EncryptDecrypt.decrypt(res.data);
            if (data.status) {
              if (toaster.current) toaster.current.success(data.message);

              props.pageRefresh();
            } else {
              if (toaster.current) toaster.current.error(data.message);
            }
          })
          .catch(err => {
            if (toaster.current) toaster.current.error(err.response);
          });
      } else if (action === "edit") {
        const params = {
          id: editedData?.id,
          external_rd_id: id,
          service_id: serviceId || props?.editedData?.services?.id
        };
        CareTeamServices.editExternalCareTeam(params)
          .then(res => {
            let data = EncryptDecrypt.decrypt(res.data);
            if (data.status) {
              if (toaster.current) toaster.current.success(data.message);
              props.pageRefresh();
              onSubmit(values, action);
            } else {
              if (toaster.current) toaster.current.error(data.message);
            }
          })
          .catch(err => {
            if (toaster.current) toaster.current.error(err.response);
          });
      }
    }
    handleSubmit();
  };

  const handlePageChange = type => {
    if (type == "prev" && pageNo > 1) {
      setPageNo(pageNo => pageNo - 1);
    } else if (type == "next" && tblData.length >= 10) {
      setPageNo(pageNo => pageNo + 1);
    }
  };

  const handleSearch = (pageNo = 1) => {
    let { values, isValid, handleSubmit } = props;
    if (isValid) {
      setLoader(true);
      setSearchText(true);
      const params = {
        first_name: values.first_name,
        last_name: values.last_name,
        provider_npi: values.provider_npi,
        state: values.state,
        page: pageNo,
        limit: TABLE.LIMIT
      };
      CareTeamServices.searchExternalCareTeam(params)
        .then(res => {
          let data = EncryptDecrypt.decrypt(res.data);
          if (data.status) {
            setTblData(data?.data.rows);
            setLoader(false);
          } else {
            if (toaster.current) toaster.current.error(data.message);
            setLoader(false);
          }
        })
        .catch(err => {
          if (toaster.current) toaster.current.error("Something went wrong!");
          setLoader(false);
        });
    }
    handleSubmit();
  };

  const columns = [
    {
      Header: "NPI",
      accessor: "provider_npi",
      className: "",
      filterable: false,
      headerClassName: "react-table-header-class ",
      width: 120,
      sortable: false
    },
    {
      Header: "First Name",
      accessor: "first_name",
      className: "",
      filterable: false,
      headerClassName: "react-table-header-class ",
      width: 120,
      sortable: false
    },
    {
      Header: "Last Name",
      accessor: "last_name",
      className: "",
      filterable: false,
      headerClassName: "react-table-header-class ",
      width: 120,
      sortable: false
    },
    {
      Header: "Address",
      accessor: "address",
      className: "",
      filterable: false,
      headerClassName: "react-table-header-class ",
      width: 120,
      sortable: false
    },
    {
      Header: "City",
      accessor: "city",
      className: "",
      filterable: false,
      headerClassName: "react-table-header-class",
      width: 120,
      sortable: false
    },
    {
      Header: "State",
      accessor: "state",
      className: "",
      filterable: false,
      headerClassName: "react-table-header-class ",
      width: 80,
      sortable: false
    },
    {
      Header: "Postal Code",
      accessor: "zip",
      className: "",
      filterable: false,
      headerClassName: "react-table-header-class ",
      width: 120,
      sortable: false
    },
    {
      Header: "Taxonomy",
      accessor: "taxonomy",
      className: "",
      filterable: false,
      headerClassName: "react-table-header-class ",
      width: 180,
      sortable: false
    },
    {
      Header: "Action",
      accessor: "action",
      className: "",
      headerClassName: "react-table-header-class",
      sortable: false,
      filterable: false,
      width: 150,
      Cell: colProps => (
        <div className="react-action-class">
          <Button
            className="c-btn c-info mr-10"
            onClick={() => formAction(colProps.original.id)}
          >
            <div className="fs-14 medium-text">Select</div>
          </Button>
        </div>
      ) // Custom cell components!
    }
  ];

  const Error = props => {
    const field1 = props.field;
    if ((errors[field1] && touched[field1]) || submitCount > 0) {
      return (
        <div className={props.class ? props.class : "error-msg"}>
          {errors[field1]}
        </div>
      );
    } else {
      return <span />;
    }
  };

  return (
    <Wrapper>
      <div className="flex flex-y p-2">
        <p className="pb-2 fs-16">
          Please note: this is a list of the external providers already added to
          the system. If the provider you are looking for is not here. Please
          add them first in External Provider Management.
        </p>
        <div className="ptb-2">
          <label className="fs-16 ">Service *</label>
          <Dropdown isOpen={serviceDropdownOpen} toggle={toggleService}>
            <DropdownToggle caret size="md">
              {serviceId ? serviceName : "Select"}
            </DropdownToggle>
            <DropdownMenu
              modifiers={{
                setMaxHeight: {
                  enabled: true,
                  order: 890,
                  fn: data => {
                    return {
                      ...data,
                      styles: {
                        ...data.styles,
                        overflow: "auto",
                        maxHeight: "300px"
                      }
                    };
                  }
                }
              }}
            >
              {serviceList.length > 0 &&
                serviceList.map((result, i) => {
                  return (
                    <DropdownItem
                      key={i}
                      onClick={() => {
                        setServiceId(result.id);
                        setServiceName(`${result.name}`);
                      }}
                    >
                      {result.name}
                    </DropdownItem>
                  );
                })}
            </DropdownMenu>
          </Dropdown>
        </div>

        <div className="flex-x space-between">
          <div className="flex-1 ">
            <div className="pr-2">
              <label className="fs-16 ">First name:</label>
              <input
                type="text"
                className="form-control react-form-input"
                id="first_name"
                onChange={handleChange}
                onBlur={handleBlur}
                value={values.first_name}
              />
            </div>
          </div>

          <div className="flex-1  ">
            <div className="pr-2">
              <label className="fs-16 ">Last name:</label>
              <input
                type="text"
                className="form-control react-form-input"
                id="last_name"
                onChange={handleChange}
                onBlur={handleBlur}
                value={values.last_name}
              />
            </div>
          </div>

          <div className="flex-1 ">
            <div className="pr-2">
              <label className="fs-16 ">NPI:</label>
              <input
                type="number"
                className="form-control react-form-input"
                id="provider_npi"
                onChange={handleChange}
                onBlur={handleBlur}
                value={values.provider_npi}
              />
            </div>
          </div>

          <div className="flex flex-1 flex-row">
            <div className="pr-2">
              <label className="fs-16 ">State</label>
              <Dropdown isOpen={stateDropdownOpen} toggle={toggleState}>
                <DropdownToggle caret size="md">
                  {stateCode ? stateName : "Select State"}
                </DropdownToggle>
                <DropdownMenu
                  modifiers={{
                    setMaxHeight: {
                      enabled: true,
                      order: 890,
                      fn: data => {
                        return {
                          ...data,
                          styles: {
                            ...data.styles,
                            overflow: "auto",
                            maxHeight: "300px"
                          }
                        };
                      }
                    }
                  }}
                >
                  <DropdownItem
                    onClick={() => {
                      setFieldValue("state", "");
                      setStateName("Select State");
                    }}
                  >
                    Select None
                  </DropdownItem>
                  {stateList.length > 0 &&
                    stateList.map((result, i) => {
                      return (
                        <DropdownItem
                          key={i}
                          onClick={() => {
                            setFieldValue("state", result.code);
                            setStateCode(result.code);
                            setStateName(`${result.name}`);
                          }}
                        >
                          {result.name}
                        </DropdownItem>
                      );
                    })}
                </DropdownMenu>
              </Dropdown>
            </div>
            <div className="align-self-end">
              {searchText && (
                <Button
                  type="button"
                  className="c-primary c-btn form-button fs-16 demi-bold-text"
                  // style={{ maxWidth: "50px" }}
                  onClick={() => {
                    setSearchText(false);
                    setServiceId(null);
                    setServiceName(null);
                    handleResetForm();
                  }}
                  title="Undo/Clear"
                >
                  Clear
                </Button>
              )}
            </div>
          </div>
          <div className="flex-1 align-self-end">
            <Button
              type="button"
              className="c-btn c-info form-button fs-16 demi-bold-text"
              style={{ maxWidth: "125px" }}
              onClick={() => {
                setPageNo(1);
                handleSearch();
              }}
              disabled={
                !serviceId ||
                (!values?.first_name &&
                  !values?.last_name &&
                  !values?.provider_npi)
              }
            >
              Filter
            </Button>
          </div>
        </div>

        <div className="flex-x space-between">
          <div className="flex-1">
            <Error field="first_name" />
          </div>
          <div className="flex-1">
            <Error field="last_name" />
          </div>
          <div className="flex-1">
            <Error field="provider_npi" />
          </div>
          <div className="flex-1">
            <Error field="state" />
          </div>
          <div className="flex-1"></div>
        </div>

        <div className="roe-card-body">
          <ReactTable
            style={{
              border: "none",
              boxShadow: "none"
            }}
            data={tblData}
            columns={columns}
            minRows={2}
            manual
            showPaginationBottom={false}
            loading={loader}
            LoadingComponent={Loader}
          />
          <div className="flex flex-x right pr-4 ">
            <div className="pr-3 cursor-pointer">
              <i
                class="fas fa-backward"
                onClick={() => handlePageChange("prev")}
              ></i>
            </div>
            <div className="cursor-pointer">
              <i
                class="fas fa-forward"
                onClick={() => handlePageChange("next")}
              ></i>
            </div>
          </div>
        </div>
      </div>
      <Toaster ref={toaster} />
    </Wrapper>
  );
};

export default compose(enhancer)(AddExternalProviderModal);
